"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTableRow;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["prefixCls", "rowKey", "store", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function createTableRow() {
  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tr';
  var tableStore = arguments.length > 1 ? arguments[1] : undefined;
  var BodyRow = /*#__PURE__*/function (_React$Component) {
    function BodyRow(props) {
      var _this;
      (0, _classCallCheck2.default)(this, BodyRow);
      _this = _callSuper(this, BodyRow, [props]);
      (0, _defineProperty2.default)(_this, "unsubscribe", void 0);
      var _tableStore$getState = tableStore.getState(),
        selectedRowKeys = _tableStore$getState.selectedRowKeys;
      _this.state = {
        selected: selectedRowKeys.indexOf(props.rowKey) >= 0
      };
      return _this;
    }
    (0, _inherits2.default)(BodyRow, _React$Component);
    return (0, _createClass2.default)(BodyRow, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (tableStore) {
          this.subscribe();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
      }
    }, {
      key: "subscribe",
      value: function subscribe() {
        var _this2 = this;
        var rowKey = this.props.rowKey;
        this.unsubscribe = tableStore.subscribe(function () {
          var _tableStore$getState2 = tableStore.getState(),
            selectedRowKeys = _tableStore$getState2.selectedRowKeys;
          var selected = selectedRowKeys.indexOf(rowKey) >= 0;
          if (selected !== _this2.state.selected) {
            _this2.setState({
              selected: selected
            });
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          rowKey = _this$props.rowKey,
          store = _this$props.store,
          children = _this$props.children,
          rowProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
        var className = (0, _classnames.default)(this.props.className, {
          'row-selected': this.state.selected
        });
        rowProps.className = className;
        return /*#__PURE__*/React.createElement(Component, rowProps, children);
      }
    }]);
  }(React.Component);
  return BodyRow;
}